/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */
import createCompanyLogosComponent from '../../utils/createCompanyLogosComponent';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var FoxMonoLogo = createCompanyLogosComponent(_jsxs("svg", {
  width: 56,
  height: 32,
  viewBox: "0 0 56 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [_jsx("path", {
    d: "M6.77107 10.5583V13.6779H13.3648V20.2009H6.77107V27.9288H0V4H14.3928L14.8537 10.5583H6.77107Z",
    fill: "none"
  }), _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1843 7.67831C36.4306 9.97121 37.5544 12.7391 37.5544 15.9814C37.5544 19.2472 36.4305 22.0264 34.1843 24.3196C31.9376 26.6124 29.2279 27.7588 26.0551 27.7588C22.8589 27.7588 20.1371 26.6124 17.8909 24.3196C15.6441 22.0265 14.521 19.2472 14.521 15.9814C14.521 12.739 15.6441 9.97121 17.8909 7.67831C20.1371 5.3854 22.8589 4.23889 26.0551 4.23889C29.2278 4.23889 31.9376 5.3854 34.1843 7.67831ZM24.1095 20.7756C24.1095 21.3088 24.3061 21.7718 24.7001 22.1654C25.0936 22.5595 25.5687 22.7561 26.1245 22.7561C26.6804 22.7561 27.1494 22.5595 27.5315 22.1654C27.9138 21.7718 28.1048 21.3088 28.1048 20.7756V11.0829C28.1048 10.5271 27.9138 10.0526 27.5315 9.65856C27.1495 9.26508 26.6805 9.06795 26.1245 9.06795C25.5687 9.06795 25.0937 9.26508 24.7001 9.65856C24.306 10.0526 24.1095 10.5271 24.1095 11.0829V20.7756Z",
    fill: "none"
  }), _jsx("path", {
    d: "M44.7153 21.9378L48.1183 27.9999H55.7402L48.5083 15.5213L55.0666 4H47.6577L44.8217 9.17573L42.0211 4H34.3638L41.064 15.5923L33.9739 28H41.4184L44.7153 21.9378Z",
    fill: "none"
  })]
}), 'FoxMonoLogo', 'CompanyMono');
export default FoxMonoLogo;